var map = {
	"./aut-de.json": "955c",
	"./aut-en.json": "0667",
	"./deu-de.json": "fc28",
	"./deu-en.json": "3bd5",
	"./nld-en.json": "5d57",
	"./nld-nl.json": "78fb",
	"./old-deu-en.json": "5b41",
	"./usa-en.json": "46fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";